import React from 'react';
import cx from 'classnames';

import SwitcherLayout from '../SwitcherLayout';

import stylesheet from './Modal.css';

export type ModalBodyProps = {
  children?: React.ReactNode;
  className?: string;
  mobileOrderReverse?: boolean;
};

const ModalBody = ({
  children,
  className,
  mobileOrderReverse,
  ...rest
}: ModalBodyProps) => {
  return (
    <div className={cx(stylesheet.body, className)} {...rest}>
      <SwitcherLayout
        gap={0}
        className={cx({ [stylesheet.mobileOrderReverse]: mobileOrderReverse })}
      >
        {children}
      </SwitcherLayout>
    </div>
  );
};

export default ModalBody;
